import { Stack, Loading, Text, keyframes } from "prism-react";

const fadeIn = keyframes({
  "0%": { opacity: 0 },
  "80%": { opacity: 0 },
  "100%": { opacity: 1 },
});

export const DevtoolLoading = ({ message }: { message?: string }) => (
  <Stack
    css={{
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
      animation: `${fadeIn} 1s ease-in`,
    }}
    gap={4}
  >
    <Loading size={12} />
    {message ? <Text>{message}</Text> : null}
  </Stack>
);
